var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJourneyBuilder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 128,
    viewBox: "0 0 220 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5711_234257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220 57.6071L194.648 47.707L188.37 63.7857L213.722 73.6857L220 57.6071Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.99 57.623C218.583 58.2016 217.176 58.7319 215.765 59.2946C214.355 59.8574 212.937 60.3644 211.537 60.8879C210.137 61.4114 208.587 61.9728 207.118 62.5027L206.985 62.5572L203.068 63.9486L202.875 64.0085L202.779 63.8358L200.842 60.1535L200.776 60.0265C200.048 58.6399 199.329 57.2438 198.618 55.8381C197.938 54.507 197.257 53.1517 196.591 51.8071C195.926 50.4626 195.243 49.0873 194.617 47.7148C195.378 48.9761 196.104 50.2768 196.847 51.5599C197.59 52.8429 198.31 54.1462 199.027 55.4579C199.832 56.9033 200.629 58.3635 201.419 59.8386C202.013 60.9336 202.604 62.0369 203.195 63.1403C204.373 62.7279 205.557 62.3129 206.735 61.9146C208.312 61.3736 209.888 60.8386 211.464 60.3098C212.876 59.839 214.288 59.3782 215.701 58.9274C217.167 58.4826 218.584 58.0382 219.99 57.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.344 60.2153L201.305 60.229C201.125 60.2938 200.942 60.3523 200.754 60.4045C199.908 60.6958 199.058 60.9571 198.199 61.1951C197.151 61.4947 196.097 61.7627 195.034 62.0275C193.972 62.2922 192.915 62.516 191.863 62.7415C190.811 62.9669 189.721 63.1535 188.635 63.2933C189.667 62.9204 190.711 62.605 191.757 62.3095C192.803 62.0141 193.865 61.7394 194.917 61.4756C195.97 61.2118 197.04 60.9787 198.115 60.7672C198.969 60.5942 199.827 60.4329 200.697 60.329L201.3 60.2415L201.344 60.2153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.858 73.1424C213.154 72.3035 212.498 71.43 211.858 70.5488C211.219 69.6677 210.602 68.7663 209.989 67.8666C209.376 66.9669 208.777 66.0337 208.226 65.1101C207.76 64.3543 207.311 63.5908 206.89 62.8046L206.605 62.2983C206.605 62.2983 206.605 62.2982 206.586 62.2617L206.615 62.2973L207 62.7703C207.547 63.4663 208.07 64.1524 208.601 64.8419C209.244 65.7247 209.857 66.6244 210.468 67.5283C211.08 68.4322 211.662 69.3488 212.227 70.2831C212.793 71.2174 213.352 72.1685 213.858 73.1424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9804 21.1502C34.9568 23.5285 44.5276 23.1621 44.5276 23.1621L38.6208 19.8176C40.5831 18.4582 42.032 16.4898 42.7351 14.2278C43.4381 11.9658 43.3547 9.54146 42.4981 7.3434C41.6415 5.14534 40.0613 3.30096 38.0111 2.106C35.9608 0.911043 33.5592 0.434746 31.1913 0.753486C28.8234 1.07223 26.6265 2.16754 24.9528 3.86378C23.2791 5.56002 22.2256 7.75892 21.9612 10.1079C21.6968 12.4568 22.2369 14.8198 23.4948 16.8177C24.7527 18.8157 26.6556 20.333 28.8983 21.1263",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0703 7.14062L25.8617 10.5849",
    stroke: "white",
    strokeWidth: 0.74154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2109 9.91797L27.0024 13.3623",
    stroke: "white",
    strokeWidth: 0.74154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3359 12.6992L28.1306 16.1425",
    stroke: "white",
    strokeWidth: 0.74154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5711_234257)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.4531,
    y: 12.0781,
    width: 140.893,
    height: 100.85,
    rx: 2.37293,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4531 14.4511C47.4531 13.1405 48.5155 12.0781 49.8261 12.0781H185.973C187.283 12.0781 188.346 13.1405 188.346 14.4511V26.1674H47.4531V14.4511Z",
    fill: "#22C55E"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 32.8438,
    width: 17.797,
    height: 7.4154,
    rx: 1.48308,
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.664,
    y: 84.75,
    width: 17.797,
    height: 7.4154,
    rx: 1.48308,
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.555,
    y: 47.6758,
    width: 26.6955,
    height: 7.4154,
    rx: 1.48308,
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.8906,
    y: 69.9219,
    width: 26.6955,
    height: 7.4154,
    rx: 1.48308,
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.211,
    y: 69.9219,
    width: 26.6955,
    height: 7.4154,
    rx: 1.48308,
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.084,
    y1: 40.2578,
    x2: 118.084,
    y2: 47.6732,
    stroke: "#E5E7EB",
    strokeWidth: 0.37077
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.084,
    y1: 55.0898,
    x2: 118.084,
    y2: 62.5052,
    stroke: "#E5E7EB",
    strokeWidth: 0.37077
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.4276,
    y1: 62.5039,
    x2: 88.4276,
    y2: 69.9193,
    stroke: "#E5E7EB",
    strokeWidth: 0.37077
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.748,
    y1: 62.5039,
    x2: 147.748,
    y2: 69.9193,
    stroke: "#E5E7EB",
    strokeWidth: 0.37077
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2422 62.3203L147.936 62.3203",
    stroke: "#E5E7EB",
    strokeWidth: 0.37077
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.748,
    y1: 77.3359,
    x2: 147.748,
    y2: 84.7513,
    stroke: "#E5E7EB",
    strokeWidth: 0.37077
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.688 126.261V125.999C138.355 125.999 139.022 125.957 139.678 125.911L139.713 126.174C139.056 126.219 138.38 126.247 137.688 126.261ZM135.2 126.23C134.543 126.205 133.871 126.163 133.209 126.107L133.249 125.848C133.916 125.901 134.583 125.943 135.24 125.971L135.2 126.23ZM142.201 125.904L142.122 125.648C142.784 125.55 143.426 125.435 144.038 125.298L144.147 125.55C143.52 125.687 142.863 125.806 142.196 125.904H142.201ZM130.721 125.844C130.084 125.76 129.423 125.662 128.761 125.554L128.845 125.298C129.502 125.407 130.154 125.501 130.791 125.585L130.721 125.844ZM126.337 125.102C125.705 124.969 125.063 124.825 124.426 124.674L124.546 124.426C125.178 124.576 125.815 124.72 126.442 124.85L126.337 125.102ZM146.501 124.909L146.342 124.671C146.938 124.473 147.516 124.25 148.073 124.002L148.272 124.226C147.697 124.478 147.103 124.706 146.491 124.909H146.501ZM122.078 124.072C121.461 123.9 120.834 123.722 120.222 123.533L120.371 123.294C120.978 123.476 121.6 123.645 122.212 123.827L122.078 124.072ZM150.283 123.151L150.029 122.954C150.515 122.645 150.968 122.31 151.382 121.953L151.671 122.117C151.243 122.486 150.776 122.832 150.273 123.151H150.283ZM117.938 122.8C117.344 122.602 116.747 122.392 116.146 122.17L116.315 121.939C116.917 122.156 117.51 122.362 118.102 122.562L117.938 122.8ZM113.957 121.336C113.369 121.105 112.797 120.867 112.23 120.636L112.419 120.411C112.986 120.65 113.558 120.884 114.141 121.112L113.957 121.336ZM153.079 120.636L152.751 120.509C153.063 120.103 153.331 119.68 153.552 119.245L153.9 119.336C153.669 119.785 153.39 120.22 153.064 120.639L153.079 120.636ZM110.105 119.697C109.543 119.441 108.99 119.178 108.443 118.916L108.657 118.698C109.199 118.961 109.752 119.22 110.309 119.476L110.105 119.697ZM106.408 117.896C105.87 117.616 105.338 117.332 104.815 117.045L105.044 116.838C105.567 117.125 106.094 117.406 106.632 117.682L106.408 117.896ZM154.537 117.616L154.174 117.57C154.281 117.114 154.349 116.653 154.378 116.19H154.751C154.72 116.67 154.643 117.147 154.522 117.619L154.537 117.616ZM102.855 115.952C102.357 115.651 101.83 115.349 101.327 115.045L101.566 114.845C102.064 115.15 102.561 115.451 103.094 115.749L102.855 115.952ZM154.308 114.46C154.244 114.008 154.149 113.542 154.02 113.08L154.388 113.03C154.517 113.503 154.617 113.973 154.677 114.432L154.308 114.46ZM99.451 113.882C98.9534 113.566 98.4558 113.251 97.9582 112.932L98.2169 112.74C98.7013 113.06 99.1889 113.375 99.6799 113.686L99.451 113.882ZM96.1717 111.724C95.6741 111.398 95.2213 111.069 94.7485 110.739L95.0123 110.55C95.485 110.883 95.9577 111.209 96.4355 111.535L96.1717 111.724ZM92.9671 109.492C92.4993 109.16 92.0365 108.823 91.5737 108.487L91.8375 108.305L93.2308 109.307L92.9671 109.492ZM89.847 107.219L88.4686 106.2L88.7423 106.021L90.1207 107.037L89.847 107.219ZM86.7518 104.928L85.3734 103.912L85.6471 103.73L87.0205 104.746L86.7518 104.928ZM83.6516 102.644C83.1889 102.294 82.731 101.971 82.2633 101.635L82.532 101.45L83.9204 102.462L83.6516 102.644ZM80.5167 100.392L79.1084 99.3967L79.3721 99.2111L80.7854 100.206L80.5167 100.392ZM77.3319 98.1672L75.8938 97.1968L76.1476 97.0042L77.5907 97.978L77.3319 98.1672ZM74.0725 95.9988C73.5749 95.6836 73.0773 95.3683 72.5796 95.053L72.8284 94.8568C73.3261 95.1721 73.8237 95.4909 74.3213 95.8062L74.0725 95.9988ZM70.7335 93.897C70.2359 93.5923 69.7382 93.2875 69.2406 92.9862L69.4795 92.7831C69.9771 93.0878 70.4996 93.3961 70.9972 93.7008L70.7335 93.897ZM67.3049 91.8653C66.8073 91.571 66.2748 91.2803 65.7473 90.986L65.9812 90.7793C66.5087 91.0736 67.0262 91.3678 67.5388 91.6621L67.3049 91.8653ZM63.7817 89.9001C63.2841 89.6163 62.7268 89.3361 62.1844 89.0559L62.4083 88.8457C62.9507 89.1259 63.4832 89.4062 64.0057 89.6899L63.7817 89.9001ZM60.169 88.0295L58.5319 87.2273L58.7458 87.0101C59.2982 87.2798 59.8456 87.5461 60.383 87.8158L60.169 88.0295ZM56.4668 86.2499C55.9144 85.9942 55.3571 85.7385 54.7948 85.4863L54.9938 85.2656C55.5611 85.5178 56.1184 85.7735 56.6708 86.0293L56.4668 86.2499ZM52.6799 84.558C52.1176 84.3163 51.5503 84.0746 50.9731 83.8329L51.1621 83.6087C51.7444 83.8504 52.3116 84.0921 52.874 84.3338L52.6799 84.558ZM48.8184 82.9536C48.2461 82.7224 47.6689 82.4947 47.0817 82.253L47.2608 82.0218C47.848 82.253 48.4302 82.4807 49.0025 82.7224L48.8184 82.9536ZM44.8872 81.4333C44.305 81.2161 43.7178 81.0024 43.1206 80.7852L43.2898 80.554C43.887 80.7677 44.4791 80.9849 45.0614 81.2021L44.8872 81.4333ZM40.9062 80.0006C40.319 79.7939 39.7169 79.5907 39.1148 79.3875L39.274 79.1493C39.8811 79.3525 40.4783 79.5592 41.0705 79.7624L40.9062 80.0006ZM36.8556 78.6449L35.0393 78.0669L35.1886 77.8287C35.8057 78.0179 36.4127 78.2105 37.0099 78.4067L36.8556 78.6449ZM32.7553 77.3663C32.1482 77.1841 31.5361 77.016 30.9141 76.8233L31.0584 76.5781L32.8996 77.1246L32.7553 77.3663Z",
    fill: "#A5B4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7751 75.1095L27.8516 74.7421L27.9856 74.3945L28.9141 74.762L28.7751 75.1095Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9524 68.8911L33.2294 77.9027L26.3428 72.5206L0.0078125 62.9727L29.9524 68.8911Z",
    fill: "#FDE047"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.9524 68.8911L33.2294 77.9027L26.3428 72.5206L0.0078125 62.9727L29.9524 68.8911Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4609 74.6198L33.2313 77.9017L26.3447 72.5195L25.4609 74.6198Z",
    fill: "#374151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3428 72.5206L0.0078125 62.9727L21.606 84.0495L26.3428 72.5206Z",
    fill: "#FDE047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9524 68.8896L40.8955 61.8242L0.0078125 62.9712L29.9524 68.8896Z",
    fill: "#FDE047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8495 19.2319C55.8483 19.5482 55.7534 19.857 55.5767 20.1194C55.4001 20.3818 55.1497 20.5859 54.8571 20.7061C54.5645 20.8263 54.2429 20.8571 53.9329 20.7946C53.6228 20.7321 53.3382 20.5792 53.115 20.3551C52.8918 20.131 52.74 19.8458 52.6787 19.5355C52.6175 19.2252 52.6496 18.9037 52.7709 18.6116C52.8922 18.3195 53.0974 18.0699 53.3604 17.8943C53.6235 17.7187 53.9327 17.625 54.249 17.625C54.4597 17.625 54.6684 17.6666 54.863 17.7474C55.0576 17.8283 55.2343 17.9467 55.383 18.096C55.5317 18.2453 55.6495 18.4225 55.7295 18.6175C55.8096 18.8124 55.8504 19.0212 55.8495 19.2319Z",
    fill: "#FACC15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3808 19.2319C62.3795 19.5482 62.2846 19.857 62.108 20.1194C61.9313 20.3818 61.6809 20.5859 61.3884 20.7061C61.0958 20.8263 60.7742 20.8571 60.4641 20.7946C60.154 20.7321 59.8695 20.5792 59.6462 20.3551C59.423 20.131 59.2712 19.8458 59.21 19.5355C59.1487 19.2252 59.1808 18.9037 59.3021 18.6116C59.4235 18.3195 59.6286 18.0699 59.8917 17.8943C60.1547 17.7187 60.4639 17.625 60.7802 17.625C60.991 17.625 61.1996 17.6666 61.3942 17.7474C61.5888 17.8283 61.7655 17.9467 61.9143 18.096C62.063 18.2453 62.1807 18.4225 62.2608 18.6175C62.3409 18.8124 62.3816 19.0212 62.3808 19.2319Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9199 19.2319C68.9186 19.5482 68.8237 19.857 68.647 20.1194C68.4704 20.3818 68.22 20.5859 67.9274 20.7061C67.6348 20.8263 67.3132 20.8571 67.0032 20.7946C66.6931 20.7321 66.4085 20.5792 66.1853 20.3551C65.9621 20.131 65.8103 19.8458 65.749 19.5355C65.6878 19.2252 65.7199 18.9037 65.8412 18.6116C65.9625 18.3195 66.1677 18.0699 66.4307 17.8943C66.6938 17.7187 67.003 17.625 67.3193 17.625C67.53 17.625 67.7387 17.6666 67.9333 17.7474C68.1279 17.8283 68.3046 17.9467 68.4533 18.096C68.602 18.2453 68.7198 18.4225 68.7999 18.6175C68.8799 18.8124 68.9207 19.0212 68.9199 19.2319Z",
    fill: "#4ADE80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5711_234257",
    x: 41.5208,
    y: 7.62888,
    width: 152.755,
    height: 112.714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.48308
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.96616
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5711_234257"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5711_234257",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5711_234257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 128,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJourneyBuilder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/journey-builder.49ca2b63a50538e8ead95a79480607ab.svg";